module.exports = __webpack_public_path__ + "static/media/profit.1f425663.png";